import { init } from "./lib/hub";
import type { Permission } from "./lib/hub";

export interface M2mStoragePermission extends Permission {}

/**
 * Init the hub.
 */
const initM2mStorageHub = (permissions: M2mStoragePermission[]) => {
  init(permissions);
};

export const m2mStorageHub = {
  init: initM2mStorageHub,
};
